var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.72 0 0 6.496 0 14.5C0 22.504 6.72 29 15 29C23.28 29 30 22.504 30 14.5C30 6.496 23.28 0 15 0ZM15 23.925C13.755 23.925 12.75 22.9535 12.75 21.75H17.25C17.25 22.9535 16.245 23.925 15 23.925ZM22.5 20.3H7.5V18.85L9 17.4V13.6155C9 10.5415 10.545 7.9315 13.5 7.25V6.525C13.5 5.6985 14.145 5.075 15 5.075C15.855 5.075 16.5 5.6985 16.5 6.525V7.25C19.455 7.9315 21 10.556 21 13.6155V17.4L22.5 18.85V20.3Z",
    fill: "#F98A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationicon);
export default __webpack_public_path__ + "static/media/Notification icon.30bdec558f199753501f1bd325f35f8d.svg";
export { ForwardRef as ReactComponent };